import Image from 'next/image';
import Link from 'next/link';

function CarouselCard({ cardData }) {
  return (
    <div className='h-[570px] md:h-[725px] w-[293px] md:w-[427px] relative snap-center mr-2 md:mr-6 carousel-card'>
      <div className='absolute w-full h-full flex flex-col justify-between p-4 md:p-8 text-brown-100'>
        <div className='flex flex-col'>
          <h3
            dangerouslySetInnerHTML={{ __html: cardData?.topTextOne?.html }}
            data-testid='carousel-card-text1'
          />
          <h6
            dangerouslySetInnerHTML={{ __html: cardData?.topTextTwo?.html }}
            data-testid='carousel-card-text2'
          />
        </div>
        <div className='min-h-[140px]'>
          <h3
            dangerouslySetInnerHTML={{ __html: cardData?.buttomText?.html }}
            data-testid='carousel-card-text3'
          />
          <h6
            className='secondary-bottom-text'
            dangerouslySetInnerHTML={{ __html: cardData?.bottomTextTwo?.html }}
            data-testid='carousel-card-text4'
          />
        </div>
      </div>

      <div className='inline md:hidden' data-testid='carousel-card-image-mobile'>
        <Image
          src={cardData?.mobileImage?._publishUrl}
          alt={cardData?.imageAltText}
          width={cardData?.mobileImage?.width || 293}
          height={cardData?.tabletImage?.height || 570}
          style={{ width: '100%', height: 'auto' }}
          loading='lazy'
        />
      </div>
      <div className='hidden md:inline' data-testid='carousel-card-image-desktop'>
        <Image
          src={cardData?.desktopImage?._publishUrl}
          alt={cardData?.imageAltText}
          width={cardData?.desktopImage?.width || 427}
          height={cardData?.desktopImage?.height || 570}
          style={{ width: '100%', height: 'auto' }}
          loading='lazy'
        />
      </div>
    </div>
  );
}

export default function LinkWrappedCarouselCard({ cardData }) {
  if (cardData?.link) {
    return (
      <Link href={cardData?.link} className='carousel-linkWrapper'>
        <CarouselCard cardData={cardData} />
      </Link>
    );
  }
  return <CarouselCard cardData={cardData} />;
}
